@if (component) {
<div class="w-12 hero-banner pos-relative">
    <div class="overflow-hidden"
         [ngClass]="[component?.elements[0]?.ratio || 'ratio-16-35 ratio-4-3-m']"
         *ifSize="'!S'">
        <local-shell/>
        @if (component?.elements?.length && component?.elements[0].image) {
        <img class="rf"
             [image]="component?.elements[0].image">
        }
    </div>
    @if (component?.elements?.length) {
    <carousel class="fill-x fill-l fill-m"
              [ngClass]="{'_equal-slides-height': client.isS && component?.equalSlidesHeight}"
              [slidesPerView]="1"
              [navigation]="false"
              [spaceBetween]="0"
              [scrollbar]="false"
              [pagination]="true"
              [loop]="component?.elements?.length>1"
              [autoplay]="{delay: 5000,
                    disableOnInteraction:false}"
              [speed]="1500"
              imageViewRoot>
        @for (item of component.elements; track item) {
        <ng-template swiperSlide>
            <div class="flex flex-column _swiper-slide-wrap"
                 [elementHeight]="uid">
                <href [link]="item.image_link">
                    <div class="overflow-hidden"
                         [ngClass]="[item.ratio || 'ratio-16-35 ratio-4-3-m ratio-3-4-s']">
                        <local-shell />
                        @if (item.variant!=='video') {
                        <img class="rf"
                             [image]="item.image" />
                        }
                    </div>
                </href>
                @if (item.variant==='video') {
                <div>
                    <youtube-player class="fill"
                                    [video-id]="item.video_id"
                                    [background]="true"
                                    [muted]="true">
                    </youtube-player>
                </div>
                }
                @if (!isTextMobileUnderImage(item)) {
                <href [link]="item.image_link">
                    <div [ngClass]="heroBannerClass(item)"
                         class="pos-absolute p-a-8-m p-b-12-m p-a-4-s p-b-12-s z-1 p-a-10-l w-5 w-12-m w-12-s flex flex-column content-hero-banner"
                         [ngStyle]="{'background-color' : item.variant === 'split_hero' ? item.background_color : 'transparent',
                                       'color': item.font_color || 'black'}">
                        <ng-container *ngTemplateOutlet="heroBanner, context:{$implicit: item}"></ng-container>
                    </div>
                </href>
                }
                @if (isTextMobileUnderImage(item)) {
                <div [ngClass]="heroBannerClass(item)"
                     class="p-a-3 p-b-1 z-1 p-a-10-l w-5 w-12-m w-12-s flex flex-column content-hero-banner"
                     [ngStyle]="{'background-color' : item.variant === 'split_hero' ? item.background_color : 'transparent',
                                        'color': item.font_color || 'black'}">
                    <ng-container *ngTemplateOutlet="heroBanner, context:{$implicit: item}"></ng-container>
                </div>
                }
            </div>
        </ng-template>
        }
    </carousel>
    }
</div>
}

<ng-template #heroBanner
             let-item>

    <!-- main title -->
    <span class="o1"
          *iCms="'main_title' of item; content: 'html'"></span>

    <!-- header -->
    <tag [tag]="item.tag || 'h4'">
        <div class="p-t-2"
             [ngClass]="item.header_copy_style ||''"
             *iCms="'header_copy' of item; content: 'html'"></div>
    </tag>
    <!-- body copy -->
    <div class="p1 p-t-2 p-b-2"
         *iCms="'body_copy' of item; content: 'html'"></div>
    <!-- buttons -->
    <div class="flex flex-wrap"
         [ngClass]="heroBannerButtonsClass(item)">

        @for (button of item.cta_elements; track button; let isLast = $last) {
        @if (!button.isRegularLink) {
        <button type="button"
                class="b-b p-b-1 no-wrap"
                [ngClass]="{'m-r-8' : !isLast}"
                (click)="scrollToId(button.anchorId)">
            <span class="p1"
                  [ngStyle]="{'color': item.font_color || 'black',
                      'border-color': item.font_color || 'black'}"
                  *iCms="'cta_copy' of button">
            </span>
        </button>
        }
        @if (button.isRegularLink) {
        <href [link]="button.cta_link "
              class="b-b p-b-1 inline-block no-wrap"
              [ngClass]="{'m-r-8' : !isLast}">
            <span class="p1"
                  [ngStyle]="{'color': item.font_color || 'black',
                      'border-color': item.font_color || 'black'}"
                  *iCms="'cta_copy' of button">
            </span>
        </href>
        }
        }

    </div>
</ng-template>
